<template>
  <el-image-viewer v-if="show"
                   :url-list="urlList"
                   :initial-index="initialIndex"
                   :z-index="zIndex"
                   :on-close="close"/>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
  components: {
    ElImageViewer
  },
  props: {
    urlList: Array,
    initialIndex: {
      type: Number,
      default: 0
    },
    zIndex: {
      type: Number,
      default: 9999
    }
  },
  data () {
    return {
      show: true
    }
  },
  methods: {
    close () {
      this.show = false
      this.$emit('close')
    }
  }
}
</script>
